var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "mask",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.onClickClose.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          ref: "dialogRoot",
          staticClass: "dialog",
          attrs: {
            role: "dialog",
            "aria-modal": "true",
            "aria-labelledby": _vm.titleId,
            tabindex: "-1",
          },
        },
        [
          _c("header", { staticClass: "dialog__header" }, [
            _c(
              "h2",
              { staticClass: "dialog__title", attrs: { id: _vm.titleId } },
              [
                _vm._v(
                  " " + _vm._s(_vm.$t("proofreadingAiCancelDialog.title")) + " "
                ),
              ]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__close",
                attrs: {
                  type: "button",
                  "aria-label": _vm.$t("proofreadingAiCancelDialog.close"),
                },
                on: { click: _vm.onClickClose },
              },
              [_vm._v(" × ")]
            ),
          ]),
          _c("div", { staticClass: "dialog__body" }, [
            _c("p", { staticClass: "dialog__message" }, [
              _vm._v(_vm._s(_vm.$t("proofreadingAiCancelDialog.message"))),
            ]),
            _c("p", { staticClass: "dialog__warning" }, [
              _vm._v(_vm._s(_vm.$t(_vm.warningKey))),
            ]),
          ]),
          _c("footer", { staticClass: "dialog__footer" }, [
            _c(
              "button",
              {
                staticClass: "dialog__cancel-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickConfirm },
              },
              [_vm._v(" " + _vm._s(_vm.$t(_vm.confirmKey)) + " ")]
            ),
            _c(
              "button",
              {
                staticClass: "dialog__close-button",
                attrs: { type: "button" },
                on: { click: _vm.onClickClose },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(_vm.$t("proofreadingAiCancelDialog.dismiss")) +
                    " "
                ),
              ]
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }